import React from 'react';
import { useTranslation } from 'react-i18next';

import './aboutUs.scss';
import { WhiteCard } from 'src/components';
import { EyeIcon, InfoIcon, RocketIcon, ShieldIcon } from 'src/assets';

export const AboutUs = () => {
  const { t } = useTranslation('aboutUs');

  return (
    <div className="about-us">
      <div className="about-us__header">
        <h2 className="about-us__header__title">
          <span>ExOk</span>
          {t('title')}
        </h2>
        <h5 className="about-us__header__subtitle">{t('subtitle')}</h5>
      </div>
      <div className="about-us__content">
        <WhiteCard>
          <img src={EyeIcon} alt={EyeIcon} />
          <h4>{t('eyeTitle')}</h4>
        </WhiteCard>
        <WhiteCard>
          <img src={ShieldIcon} alt={ShieldIcon} />
          <h4>{t('shieldTitle')}</h4>
        </WhiteCard>
        <WhiteCard>
          <img src={RocketIcon} alt={RocketIcon} />
          <h4>{t('rocketTitle')}</h4>
        </WhiteCard>
      </div>
      <div className="about-us__info">
        <WhiteCard>
          <img src={InfoIcon} alt={InfoIcon} />
          <div className="about-us__info__content">
            <h5 className="about-us__info__title">{t('infoTitle')}</h5>
            <span>{t('infoSubTitle')}</span>
          </div>
        </WhiteCard>
      </div>
    </div>
  );
};
